import { startCase, toLower } from 'lodash'

export const formatUppercaseToTitleCase = (name: string) => {
  return name
    .split('-')
    .map((part) => startCase(toLower(part)))
    .join('-')
}

export const isValidUrl = (string: string) => {
  try {
    new URL(string)
    return true
  } catch {
    return false
  }
}
